<template>
    <div>
        <component :is="layout">
            <router-view></router-view>
        </component>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    computed: {
        layout() {
            return `app-default-layout`;
            // let layoutName = this.$route.meta.layout ? this.$route.meta.layout : 'default';
            // return `app-${layoutName}-layout`;
        }
    },
    mounted() {

    }
}
</script>